import { all } from "redux-saga/effects";
import { sagas as premierCollectionSearch } from "../modules/search";
import { sagas as premierCollectionRewards } from "../modules/rewards";
import { sagas as premierCollectionAvailability } from "../modules/availability";
import { sagas as premierCollectionShop } from "../modules/shop";
import { sagas as premierCollectionShopDetails } from "../modules/shop-details";

import { sagas as premierCollectionBook } from "../modules/book";
import { sagas as premierCollectionTravelWallet } from "../modules/travel-wallet";
// TODO: refactor it as a package, see https://hopper-jira.atlassian.net/browse/BF-1514
import { sagas as hotelAncillary } from "../modules/ancillary";
import { sagas as vacationRentalShop } from "../modules/vacation-rental-shop";
import { sagas as premiumCollectionOffers } from "../modules/offers";

export function* rootSaga() {
  yield all([
    premierCollectionSearch.watchMegaMenuRegions(),
    premierCollectionSearch.watchFetchPCLocationAutocomplete(),
    premierCollectionSearch.watchFetchVRLocationAutocomplete(),
    premierCollectionRewards.watchFetchRewardsAccounts(),

    premierCollectionAvailability.watchFetchPremierCollectionAvailability(),
    premierCollectionAvailability.watchFetchVacationRentalsAvailability(),
    premierCollectionAvailability.watchListPCAvailabilityPaymentMethods(),

    premierCollectionShop.watchFetchPremierCollectionShopSaga(),
    premierCollectionShop.watchCheckLifestyleEligibilitySaga(),

    premierCollectionShopDetails.watchFetchPremierCollectionShopDetailsSaga(),

    premierCollectionBook.watchFetchUserPassengers(),
    premierCollectionBook.watchDeletePassengerSaga(),
    premierCollectionBook.watchUpdateUserPassenger(),
    premierCollectionBook.watchFetchCorpUserPassengers(),

    premierCollectionBook.watchFetchPaymentMethodSaga(),
    premierCollectionBook.watchDeletePaymentMethodSaga(),
    premierCollectionBook.watchListPaymentMethodsSaga(),
    premierCollectionBook.watchVerifyPaymentMethodSaga(),

    premierCollectionBook.watchProductToEarnSaga(),
    premierCollectionBook.watchFetchAllEarnForProductSaga(),

    premierCollectionBook.watchSchedulePriceQuoteSaga(),
    premierCollectionBook.watchPollPriceQuoteSaga(),
    premierCollectionBook.watchscheduleBookSaga(),
    premierCollectionBook.watchPollConfirmationDetailsSaga(),
    premierCollectionBook.watchFetchApplicableTravelWalletItemsSaga(),

    premierCollectionBook.watchScheduleVacationRentalPriceQuoteSaga(),
    premierCollectionBook.watchPollVacationRentalsPriceQuoteSaga(),
    premierCollectionBook.watchAddMainGuestSaga(),
    premierCollectionBook.watchScheduleVacationRentalsBookSaga(),
    premierCollectionBook.watchPollVacationRentalsConfirmationDetailsSaga(),

    premierCollectionTravelWallet.watchFetchTravelWalletDetails(),
    premierCollectionTravelWallet.watchFetchTravelWalletCreditHistorySaga(),

    premiumCollectionOffers.watchFetchPremiumOffersShop(),

    hotelAncillary.watchFetchCfarOffers(),

    vacationRentalShop.watchFetchVacationRentalShopSaga(),
    vacationRentalShop.watchCheckLifestyleEligibilitySaga(),
  ]);
}
